import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const ReferencePage = ({ isOpen, onClose }) => {
    const [universities, setUniversities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
        const { t } = useTranslation();

    useEffect(() => {
        const fetchUniversities = async () => {
            try {
                const response = await axios.get('https://ai.kesifaraci.com/service/api/universities');
                if (response.data.result) {
                    // Sort universities alphabetically by name
                    const sortedUniversities = response.data.data.sort((a, b) =>
                        a.name.localeCompare(b.name, 'tr')
                    );
                    setUniversities(sortedUniversities);
                } else {
                    setError('Veri alınamadı');
                }
            } catch (error) {
                setError('Üniversite listesi yüklenirken bir hata oluştu');
                console.error('Error fetching universities:', error);
            } finally {
                setLoading(false);
            }
        };

        if (isOpen) {
            fetchUniversities();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black bg-opacity-50"
                onClick={onClose}
            />

            {/* Modal Content */}
            <div className="relative bg-white w-[90vw] max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg p-6 z-10">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 text-white hover:text-white/50"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* References Section */}
                <div className="text-center bg-[#3c4f58] text-white p-8 rounded-lg">
                    <h2 className="text-2xl font-semibold mb-4">{t('Referans Listesi')}</h2>
                    <p className="mb-6 text-lg">
                    {t('about1')}
                    </p>

                    {loading && (
                        <div className="flex justify-center items-center py-4">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                        </div>
                    )}

                    {error && (
                        <div className="text-red-300 p-4">
                            {error}
                        </div>
                    )}

                    {!loading && !error && (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {universities.map((uni) => (
                                <div
                                    key={uni.id}
                                    className="bg-white rounded-lg p-4 shadow-lg flex flex-col items-center"
                                >
                                    <div className="w-32 h-32 mb-4 relative flex items-center justify-center">
                                        <img
                                            src={`https://kesifaraci.com/assets/img/university/${uni.uni_id}.png`}
                                            alt={`${uni.name} Logo`}
                                            className="max-w-full max-h-full object-contain"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = 'https://kesifaraci.com/assets/img/university/default.png';
                                            }}
                                        />
                                    </div>
                                    <h3 className="text-gray-800 font-medium text-center mb-2">
                                        {uni.name}
                                    </h3>
                                    <span className={`px-4 py-1 rounded-full text-white text-sm ${
                                        uni.ai_status === 'abone'
                                            ? 'bg-green-500'
                                            : 'bg-yellow-500'
                                    }`}>
                                        {uni.ai_status === 'abone' ? 'Abone' : 'Deneme'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReferencePage;